import { z } from 'src/lib'

export const MensajesRequestFields = {
    CodsSistemaPrincipal: 'codsSistemaPrincipal',
    CodTipoMensaje: 'codsTipoMensaje',
    CodSistema: 'codsSistema',
    Referencia: 'referencia',
    IdMensaje: 'idMensaje',
    FechaDesde: 'fechaDesde',
    FechaHasta: 'fechaHasta',
    Estados: 'estados',
    IsResponsible: 'esResponsable'
} as const

export const schemaMensajesRequestDTO = z.object({
    [MensajesRequestFields.CodsSistemaPrincipal]: z.array(z.number()),
    [MensajesRequestFields.CodTipoMensaje]: z.array(z.number()),
    [MensajesRequestFields.CodSistema]: z.array(z.number()).optional(),
    [MensajesRequestFields.Referencia]: z.string().optional(),
    [MensajesRequestFields.IdMensaje]: z
        .string()
        .optional()
        .transform(x => Number(x)),
    [MensajesRequestFields.FechaDesde]: z.date().nullish(),
    [MensajesRequestFields.FechaHasta]: z.date().nullish(),
    [MensajesRequestFields.Estados]: z.array(z.number()),
    [MensajesRequestFields.IsResponsible]: z.boolean()
})

export type MensajesRequestDTO = z.input<typeof schemaMensajesRequestDTO>
